const returnStringFunction = (stringToVerify: string | undefined | null) => {
  return stringToVerify ? stringToVerify : '';
};

export default returnStringFunction;
